module.exports = __webpack_public_path__ + "5cc960d0.png";